import { render, staticRenderFns } from "./CheckBoxV2.vue?vue&type=template&id=19828d54&scoped=true&"
import script from "./CheckBoxV2.vue?vue&type=script&lang=js&"
export * from "./CheckBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxV2.vue?vue&type=style&index=0&id=19828d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19828d54",
  null
  
)

export default component.exports